import React from 'react';
import { Input, Button, Row, Col } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { SelectDirectory } from './Select';

const DirectoryValuesInput = ({ value = [], onChange, placeholder }) => {
  const handleAdd = () => {
    const newValue = [...value, { name: '', description: '' }];
    onChange(newValue);
  };

  const handleRemove = index => {
    const newValue = value.filter((_, i) => i !== index);
    onChange(newValue);
  };

  const handleChange = (index, key, newVal) => {
    const newValue = value.map((item, i) => (i === index ? { ...item, [key]: newVal } : item));
    onChange(newValue);
  };

  const handleCreateDirectory = () => {
    window.open('/admin/directory/new', '_blank');
  };

  return (
    <div>
      {placeholder && <div style={{ marginBottom: 8 }}>{placeholder}</div>}
      {value.map((item, index) => (
        <Row gutter={8} key={index} style={{ marginBottom: 8 }}>
          <Col span={6}>
            <Input
              placeholder="name"
              value={item.name}
              onChange={e => handleChange(index, 'name', e.target.value)}
            />
          </Col>
          <Col span={6}>
            <Input
              placeholder="description"
              value={item.description}
              onChange={e => handleChange(index, 'description', e.target.value)}
            />
          </Col>
          <Col span={10}>
            <SelectDirectory
              value={item.directory}
              onChange={selected => handleChange(index, 'directory', selected)}
            />
          </Col>
          <Col span={1}>
            <Button type="link" onClick={handleCreateDirectory} style={{ padding: 0 }}>
              New
            </Button>
          </Col>
          <Col span={1}>
            <Button danger icon={<DeleteOutlined />} onClick={() => handleRemove(index)} />
          </Col>
        </Row>
      ))}
      <Button type="dashed" onClick={handleAdd}>
        Add
      </Button>
    </div>
  );
};

export { DirectoryValuesInput };
